import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import useSession from '../hooks/useSession';
import userAPI from '../services/user'
import Toast from './layout/Toast'
import { ErrorContext } from '../context/ErrorContext'
import { UserContext } from '../context/UserContext';

const Register = () => {
  // eslint-disable-next-line no-unused-vars
  const [session, setSession] = useSession()
  const navigate = useNavigate();
  const { parseErrors } = useContext(ErrorContext)
  const { user, getL10nInstance } = useContext(UserContext)
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password2: ''
  });
  const [error, setError] = useState([]);
  const [l10n, setL10n] = useState(null)

  const {
    first_name,
    last_name,
    email,
    password,
    password2,
  } = formData;

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [session, user])

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value})
  const onSubmit = async (e) => {
    e.preventDefault()
    setError([]);
    if (password !== password2) {
      setError([{message: 'Passwords do not match'}])
    } else {
      try {
        const res = await userAPI.post({first_name, last_name, email, password})
        // setSession(res.data.token);
        setError([{message: 'User created successfully'}])
        setFormData({
          first_name: '',
          last_name: '',
          email: '',
          password: '',
          password2: ''
        })
      } catch (err) {
        const parsedErr = parseErrors(err.response.data.errors ? err.response.data.errors : (err.response.data.error ? err.response.data.error : null))
        setError(parsedErr)
      }
    }
  }
  return (
    <>
      <section className="container mx-auto px-4">
        <h1 className="text-4xl dark:text-white mb-6">{l10n && l10n.getString('Account Manager')}</h1>
        <p className="mb-6 text-xl"><i className="fas fa-user"></i>{l10n && l10n.getString('Create a new account manager')}</p>
        <form onSubmit={e => onSubmit(e)}>
          <div className="mb-6">
            <input
              className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
              type="text"
              placeholder={l10n && l10n.getString("Name")}
              name="first_name"
              value={first_name}
              onChange={ e => onChange(e) }
              required
            />
          </div>
          <div className="mb-6">
            <input
              className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
              type="text"
              placeholder={l10n && l10n.getString("Last name")}
              name="last_name"
              value={last_name}
              onChange={ e => onChange(e) }
              required
            />
          </div>
          <div className="mb-6">
            <input
              className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
              type="email"
              placeholder={l10n && l10n.getString("Email Address")}
              value={email}
              onChange={ e => onChange(e) }
              name="email"
            />
          </div>
          <div className="mb-6">
            <input
              className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
              type="password"
              placeholder={l10n && l10n.getString("Password")}
              name="password"
              value={password}
              onChange={ e => onChange(e) }
              minLength="6"
            />
          </div>
          <div className="mb-6">
            <input
              className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
              type="password"
              placeholder={l10n && l10n.getString("Confirm Password")}
              name="password2"
              value={password2}
              onChange={ e => onChange(e) }
              minLength="6"
            />
          </div>
          <input
            type="submit"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            value={l10n && l10n.getString("Create Account Manager")}
          />
        </form>
      </section>
      <Toast toast={error} time={3000} />
    </>
  )
}

export default Register